import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public loading: boolean = true;

    // 프로필 편집
    public editing: boolean = false;
    public editName: string = '';
    public editMobile: string = '';
    public saving: boolean = false;

    // 비밀번호 변경
    public showPasswordForm: boolean = false;
    public currentPassword: string = '';
    public newPassword: string = '';
    public confirmPassword: string = '';
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadProfile();
        await this.service.render();
    }

    public async loadProfile() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('profile');
        if (code === 200) {
            this.user = data.user;
        }
        this.loading = false;
        await this.service.render();
    }

    public async startEdit() {
        this.editName = this.user?.name || '';
        this.editMobile = this.user?.mobile || '';
        this.editing = true;
        await this.service.render();
    }

    public async cancelEdit() {
        this.editing = false;
        await this.service.render();
    }

    public async saveProfile() {
        if (!this.editName.trim()) {
            await this.service.alert.show({ title: '입력 오류', message: '이름은 필수입니다.', action: '확인' });
            return;
        }
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('update_profile', { name: this.editName.trim(), mobile: this.editMobile.trim() });
        this.saving = false;
        if (code === 200) {
            this.editing = false;
            await this.loadProfile();
        } else {
            await this.service.alert.show({ title: '오류', message: data?.message || '저장에 실패했습니다.', action: '확인' });
            await this.service.render();
        }
    }

    public async togglePasswordForm() {
        this.showPasswordForm = !this.showPasswordForm;
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        await this.service.render();
    }

    public async changePassword() {
        if (!this.currentPassword) {
            await this.service.alert.show({ title: '입력 오류', message: '현재 비밀번호를 입력해주세요.', action: '확인' });
            return;
        }
        if (this.newPassword.length < 6) {
            await this.service.alert.show({ title: '입력 오류', message: '새 비밀번호는 6자 이상이어야 합니다.', action: '확인' });
            return;
        }
        if (this.newPassword !== this.confirmPassword) {
            await this.service.alert.show({ title: '입력 오류', message: '새 비밀번호가 일치하지 않습니다.', action: '확인' });
            return;
        }
        this.changingPassword = true;
        await this.service.render();
        const { code, data } = await wiz.call('change_password', {
            current_password: this.currentPassword,
            new_password: this.newPassword
        });
        this.changingPassword = false;
        if (code === 200) {
            this.showPasswordForm = false;
            this.currentPassword = '';
            this.newPassword = '';
            this.confirmPassword = '';
            await this.service.alert.show({ title: '완료', message: '비밀번호가 변경되었습니다.', action: '확인' });
            await this.service.render();
        } else {
            await this.service.alert.show({ title: '오류', message: data?.message || '비밀번호 변경에 실패했습니다.', action: '확인' });
            await this.service.render();
        }
    }

    public roleLabel(role: string): string {
        const map: any = { admin: '관리자', user: '사용자' };
        return map[role] || role;
    }
}

export default PageMypageComponent;